import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import UrgencyBanner from "../components/UrgencyBanner";
import Hero from "../components/Hero";
import BuddyPeek from "../components/BuddyPeek";
import Problem from "../components/Problem";
import HowItWorks from "../components/HowItWorks";
import MeetTheBuddies from "../components/MeetTheBuddies";
import BuddyInMotion from "../components/BuddyInMotion";
import Recipes from "../components/Recipes";
import CreateYourOwnPromo from "../components/CreateYourOwnPromo";
import RecentBuddiesMarquee from "../components/RecentBuddiesMarquee";
import Products from "../components/Products";
import ParentBenefits from "../components/ParentBenefits";
import Footer from "../components/Footer";
import useSeo from "../lib/useSeo";

export default function Home() {
  const { hash } = useLocation();

  useSeo({
    title: "Plate Buddies — Your kid's very own food character. Ages 2–7.",
    description:
      "Design your child's one-of-a-kind food character in 30 seconds. Kid-friendly recipes, coloring pages, and a weekly meal-plan board — the screen-free way to make dinner an adventure.",
    url: "https://platebuddies.com/",
  });

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    let cancelled = false;
    const tryScroll = (attempt = 0) => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (el) {
        // Schedule on next frame so any final layout shift (e.g. images decoded
        // by the time the section mounts) is reflected before we measure.
        requestAnimationFrame(() => {
          if (cancelled) return;
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      } else if (attempt < 30) {
        // Up to 3s of retries — covers slow image/data fetches before the
        // target section actually mounts.
        setTimeout(() => tryScroll(attempt + 1), 100);
      }
    };
    tryScroll();
    return () => {
      cancelled = true;
    };
  }, [hash]);

  return (
    <div data-testid="page-home" className="font-body text-pb-ink overflow-x-hidden">
      <UrgencyBanner />
      <Navbar />
      <Hero />
      {/* Captain Sammy peeks up over the top edge of the dark purple
          gallery band — his first wave hello as the gallery scrolls in. */}
      <BuddyPeek
        src="/buddies/captain-sammy.png"
        alt="Captain Sammy"
        side="right"
        offset="7%"
        width={120}
        rotate={9}
        data-testid="peek-captain-sammy"
      />
      <RecentBuddiesMarquee />
      <Problem />
      <HowItWorks />
      <MeetTheBuddies />
      <BuddyInMotion />
      <Recipes />
      <CreateYourOwnPromo />
      {/* Sally Salad peeks up above the Products section — one last wave
          as the visitor approaches the kits grid. */}
      <BuddyPeek
        src="/buddies/sally-salad.png"
        alt="Sally Salad"
        side="right"
        offset="10%"
        width={110}
        rotate={8}
        data-testid="peek-sally-salad"
      />
      <Products />
      <ParentBenefits />
      <Footer />
    </div>
  );
}
